import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { Logger } from '../utils/logger';

const log = Logger.create('FirebaseConfig');

if (!import.meta.env.VITE_FIREBASE_API_KEY) {
  log.error('Firebase API key is missing. Check your .env file');
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);    // Realtime Database (Live Sessions)
const auth = getAuth(app);
const firestore = getFirestore(app);  // Firestore (Static Data)
const storage = getStorage(app);      // Firebase Storage (Files/Images)

export { database, auth, firestore, storage };